export const INVOICE_CSS = `
  @page { size: 80mm auto; margin: 0; }
  @media print {
    caption, th, td { text-align: left; font-weight: normal; }
    p { padding-bottom: 5px; font-size: 16px; }
    .company-name { font-weight: 600; padding-top: 5px; font-size: 21px; }
    .bill { padding-top: 12px; letter-spacing: 2px; }
    .text-right { text-align: right; }
    .text-center { text-align: center; }
    .m-0 { margin: 0; }
    .p-0 { padding: 0; }
  }
`;

export const  INVOICE_STYLE={
    receipt: {
        width: "80mm", // ~58mm printer
        fontSize: "10px",
        padding: "5px"
    },
    row: {
        display: "flex",
        justifyContent: "space-between"
    },
    center: {
        textAlign: "center"
    },
    bold: {
        fontWeight: "bold"
    }
}